// + - - - +
// - + - + -
// - - + - -
// - + - + -
// + - - - +
const PATTERN_X =
  '.col-B1, .col-I2, .col-G4, .col-O5, .col-B5, .col-I4, .col-G2, .col-O1'
// - - + - -
// - - + - -
// + + + + +
// - - + - -
// - - + - -
const PATTERN_PLUS =
  '.col-B3, .col-I3, .col-N1, .col-N2, .col-N4, .col-N5, .col-G3, .col-O3'
// - - - - -
// - - - - -
// + + + + +
// - - - - -
// - - - - -
const PATTERN_MINUS = `.col-B3, .col-I3, .col-G3, .col-O3`

// + - - - -
// + - - - -
// + - - - -
// + - - - -
// + + + + +
const PATTERN_L = `.col-B1, .col-B2, .col-B3, .col-B4, .col-B5, .col-I5, .col-N5, .col-G5, .col-O5`

// - + + + +
// + - - - -
// + - - - -
// + - - - -
// - + + + +
const PATTERN_C = `.col-B2, .col-B3, .col-B4, .col-I1, .col-I5, .col-N1, .col-N5, .col-G1, .col-G5, .col-O1, .col-O5`

// + + + + +
// + - - - -
// + + + + +
// + - - - -
// + + + + +
const PATTERN_E = `.col-B1, .col-B2, .col-B3, .col-B4, .col-B5, .col-I1, .col-I3, .col-I5, .col-N1, .col-N3, .col-N5, .col-G1, .col-G3, .col-G5, .col-O1, .col-O3, .col-O5`

// + - - - -
// + - - - -
// + - - - -
// + - - - -
// + + + + +
const PATTERN_M = `.col-B1, .col-B2, .col-B3, .col-B4, .col-B5, .col-I2, .col-G2, .col-O1, .col-O2, .col-O3, .col-O4, .col-O5`

// + + + + +
// + - - - +
// + - - - +
// + - - - +
// + + + + +
const PATTERN_BOX = `.col-B1, .col-B2, .col-B3, .col-B4, .col-B5, .col-I1, .col-I5, .col-N1, .col-N5, .col-G1, .col-G5, .col-O1, .col-O2, .col-O3, .col-O4, .col-O5`

// + - - - +
// + - - - +
// + - - - +
// + - - - +
// - + + + -
const PATTERN_U = `.col-B1, .col-B2, .col-B3, .col-B4, .col-I5, .col-N5, .col-G5, .col-O1, .col-O2, .col-O3, .col-O4`

// + + + + +
// - - + - -
// - - + - -
// - - + - -
// - - + - -
const PATTERN_T = `.col-B1, .col-I1, .col-N1, .col-N2, .col-N4, .col-N5, .col-G1, .col-O1`

// - - + - -
// - + + + -
// + + + + +
// - - + - -
// - - + - -
const PATTERN_UMBRELLA = `.col-B3, .col-I2, .col-I3, .col-N1, .col-N2, .col-N4, .col-N5, .col-G2, .col-G3, .col-O3`

// - - + - -
// - + + + -
// + + + + +
// - + + + -
// - - + - -
const PATTERN_DIAMOND_FULL = `.col-B3, .col-I2, .col-I3, .col-I4, .col-N1, .col-N2, .col-N4, .col-N5, .col-G2, .col-G3, .col-G4, .col-O3`

// - - + - -
// - + + + -
// + + + + +
// - + + + -
// - - + - -
const PATTERN_DIAMOND = `.col-B3, .col-I2, .col-I4, .col-N1, .col-N5, .col-G2, .col-G4, .col-O3`

export {
  PATTERN_X,
  PATTERN_PLUS,
  PATTERN_MINUS,
  PATTERN_L,
  PATTERN_C,
  PATTERN_E,
  PATTERN_M,
  PATTERN_BOX,
  PATTERN_U,
  PATTERN_T,
  PATTERN_UMBRELLA,
  PATTERN_DIAMOND,
  PATTERN_DIAMOND_FULL,
}
